module.exports = "/_next/static/images/brendan-spillane-97870d8be0e2c1e08860084cc6459487.jpg";